import { cn } from '@/lib/utils'

/**
 * Top-fold atmosphere behind nav + hero — lives on the marketing layout shell.
 * The green halo is drawn purely in CSS (radial gradient + blur + blend); see
 * `.marketing-hero-bg` in globals.css. A separate, un-blurred grain layer
 * (`.marketing-hero-noise`) dithers the low-alpha gradient so it doesn't band.
 */
export function MarketingTopFoldBackground({ className }: { className?: string }) {
  return (
    <>
      <div aria-hidden className={cn('marketing-hero-bg', className)} />
      <div aria-hidden className="marketing-hero-noise" />
    </>
  )
}
